import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { StyledSizeContainerSquare, StyledContainerLoader, StyledContainerText } from './styled/Loader.styled';

/**
 * A loading spinner that should be used every time the user is waiting some request.
*/
function Loader({ underText = '', size = 20, position = 'fixed' }) {
  const [message, setMessage] = useState('');
  const [index, setIndex] = useState(null);
  const timer = useRef();

  useEffect(() => {
    if (index === null) {
      timer.current = setTimeout(() => {
        setIndex(0);
      }, 2000);
      return;
    }
    if (Array.isArray(underText) && underText.length > 0) {
      const currentMessage = underText[index];
      const duration = Math.max(2000, currentMessage.length * 60);
      setMessage(currentMessage);
      timer.current = setTimeout(() => {
        setIndex((prev) => (prev + 1) % underText.length);
      }, duration);
    } else if (typeof underText === 'string') setMessage(underText);
  }, [index]);

  useEffect(() => () => {
    clearInterval(timer.current);
  }, []);

  return (
    <StyledContainerLoader position={position}>
      <StyledSizeContainerSquare size={size} position={position}>
        <div />
        <div />
        <div />
        <div />
      </StyledSizeContainerSquare>
      {underText !== '' ? (<StyledContainerText>{message}</StyledContainerText>) : null}
    </StyledContainerLoader>
  );
}
Loader.propTypes = {
  /**
   * Position of the loader. Choose from two options.
   */
  position: PropTypes.oneOf(['relative', 'fixed']),
  /**
   * A number determining the size of the loader.
   */
  size: PropTypes.number,
  /**
   * A string or an array of strings determining the text to be shown under the loader.
   */
  underText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
};
export default Loader;
